import { AnyAction } from '@reduxjs/toolkit'
import * as types from 'model/actionTypes'
import { NotificationsSettingsT } from 'shared/types/model'

const initialState: NotificationsSettingsT | null = null

export default function (
  state = initialState,
  action: AnyAction
): typeof initialState {
  switch (action.type) {
    case types.RECEIVE_NOTIFICATIONS_SETTINGS:
      return action.settings
    case types.CLEAR:
    case types.LOGOUT:
      return initialState
    default:
      return state
  }
}
